import { gql } from '@apollo/client';
export const InstitutionFragment = gql `
    fragment InstitutionFragment on Site {
        id: institutionId
        institutionId
        managedFeatures {
            featureId
            enabled
        }
        title
        behaviors {
            __typename
            behaviorId
        }
        privacyPolicyUrl
        profileImage {
            url
        }
        settings {
            settingGroups {
                groups {
                    __typename
                }
            }
        }
        timeZone
        identificationNumber
        details {
            behaviors {
                __typename
                behaviorId
            }
            address {
                __typename
                city
                street
                zip
                country
                state
            }
            contactPerson {
                __typename
                fullName
            }
            phone
            ean
            email
            vat
            socialMedia {
                __typename
                facebook
                instagram
                twitter
            }
            description
        }
        addressFormatting {
            format
        }
    }
`;
